import type { MotifComponent, MotifComponentProps } from '../../motif';
import { m } from '../../motif/m';

export const primaryTopicVars: MotifComponentProps<MotifComponent.TOPIC> = {
  '--topic-hover-bg-color': m('--primary-v150'),
};

export const secondaryTopicVars: MotifComponentProps<MotifComponent.TOPIC> = {
  '--topic-hover-bg-color': m('--neutral-v600'),
};

export const tertiaryTopicVars: MotifComponentProps<MotifComponent.TOPIC> = {
  '--topic-hover-bg-color': m('--neutral-v150'),
};

export const quaternaryTopicVars: MotifComponentProps<MotifComponent.TOPIC> = {
  '--topic-hover-bg-color': m('--neutral-v250'),
};
